// frontend/packs/home.js

/* eslint-disable import/first, import/newline-after-import */

import '../components/home/home-main.css';

import { Application } from 'stimulus';
export const homePage = Application.start(); // eslint-disable-line import/prefer-default-export

import 'components/resources/grid/grid';

import 'components/home/masthead/masthead';
import 'components/home/value-propositions/value-propositions';
import 'components/home/editor-cta/editor-cta';
import 'components/home/featured-clients/featured-clients';
import 'components/home/featured-grid/featured-grid';

// start split-test: resource_show_modal_view
// Keeping this here, commented out, so it can be uncommented if above split test fails
// import ResourcesGridController from '../components/resources/grid/grid-controller';
// homePage.register('resources-grid', ResourcesGridController);
// end split-test: resource_show_modal_view

import EditorCtaController from '../components/home/editor-cta/editor-cta-controller';
homePage.register('editor-cta', EditorCtaController);

import TrendingSearchesController from '../components/search/trending-searches/trending-searches-controller';
homePage.register('trending-searches', TrendingSearchesController);
